import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { isAxiosError, AxiosErrorHandler } from '@/util/AxiosErrorHandler';
import { OCMailAuthenticationResponse } from '@/components/OCMailAuthentication';

@Component({
    components: AllComponents(),
})
export default class Email extends Mixins(CommonView) {
    kurukuru: boolean = false;
    pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"},{name: "マイページ", path: "/mypage"},{name: "メール設定", path: null}];

    type: "SELECT" | "CHANGE" | "STOP" = "CHANGE";
    mode: number = 0;
    error: string = "";
    email: string = "";
    code: string = "";
    user: BASEAPI.User = BASEAPI.user();
    a: boolean = true;

    public async created() {
        this.kurukuru = true;
        if (await this.isLoginRedirect(true)) return;

        let query = this.$route.query;

        if (query.mode && query.mode == 'stop') {
            this.stopMode();
        }
        this.kurukuru = false;
    }

    public backRedirect() {
        this.$router.push("/mypage");
    }
    

    public async check() {
        //バリデーションチェック
        this.mode = 1;
    }

    public async ok(val: OCMailAuthenticationResponse) {
        this.kurukuru = true;

        let profile = await BASEAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(profile)) {
            this.error = "" + profile.data;
            return;
        }
        let user = profile.data;
        user.email = val.email;
        user.code = val.code;
        let res = await BASEAPI.UserController.putUserUsingPUT(user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
        } else {
            this.mode = 1;
        }
        this.kurukuru = false;
    }

    public async stopMode() {
        let response = await BASEAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
        } else {
            response.data.email = "";
            response.data.ngMailFlag = !response.data.ngMailFlag;
            this.user = response.data;
        }
        this.type = 'STOP';
        this.mode = 0;
    }

    public async put() {
        this.kurukuru = true;
        this.mode = 1;
        this.user.ngMailFlag = !this.user.ngMailFlag;
        let res = await BASEAPI.UserController.putUserUsingPUT(this.user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            return;
        }
        this.kurukuru = false;
    }
}
